import { motion } from 'framer-motion';

const SwapHeader = ({ routerUsed, onSettingsClick }) => {
  return (
    <div className="lr-card-header-modern">
      <div className="lr-header-content">
        <h2 className="lr-swap-title">Swap</h2>
        <div className="lr-router-badge">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/>
          </svg>
          <span>{routerUsed || 'Universal Router'}</span>
        </div>
      </div>
      <button
        className="lr-settings-btn-modern"
        type="button"
        onClick={onSettingsClick}
        data-press
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="12" r="3"/>
          <path d="M12 1v6m0 6v6m9-9h-6m-6 0H3m15.364-6.364l-4.243 4.243m-6 6l-4.243 4.243M20.364 20.364l-4.243-4.243m-6-6L5.878 5.878"/>
        </svg>
      </button>
    </div>
  );
};

export default SwapHeader;
